var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "settings-modal" },
      on: { "before-close": _vm.onBeforeClose, "before-open": _vm.onBeforeOpen }
    },
    [
      _c(
        "div",
        { staticClass: "settings-modal" },
        [
          _c("settings-header", {
            attrs: {
              title: _vm.activeView.displayName,
              "title-suffix": "Settings"
            },
            on: { close: _vm.onClose }
          }),
          _vm._v(" "),
          _c(
            "flex-grid",
            [
              _c(
                "flex-grid-item",
                { attrs: { margin: "20px" } },
                [
                  _c("settings-list", {
                    attrs: {
                      "active-view-name": _vm.activeView.name,
                      "view-list": _vm.viewList
                    },
                    on: { change: _vm.onSettingsListChange }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "flex-grid-item",
                [
                  _vm.settingsDateFormatViewActive
                    ? _c("settings-date-format", {
                        attrs: {
                          "date-format": _vm.dateFormat,
                          "date-format-options": _vm.dateFormatOptions,
                          "time-format": _vm.timeFormat,
                          "time-format-options": _vm.timeFormatOptions,
                          timezone: _vm.timezone,
                          "timezone-options": _vm.timezoneOptions
                        },
                        on: { change: _vm.onSettingsChange, close: _vm.onClose }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.settingsWorkflowHistoryViewActive
                    ? _c("settings-workflow-history", {
                        attrs: {
                          "workflow-history-event-highlight-list":
                            _vm.workflowHistoryEventHighlightList,
                          "workflow-history-event-highlight-list-enabled":
                            _vm.workflowHistoryEventHighlightListEnabled
                        },
                        on: { change: _vm.onSettingsChange, close: _vm.onClose }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae1c36d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae1c36d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/settings-modal/component.vue
// module id = 1578
// module chunks = 0